// extracted by mini-css-extract-plugin
export default {"wrapper":"ControllerBasicInfo_wrapper__ra+Nc"};